import {
    AfterContentInit,
    Component,
    ContentChildren,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    QueryList,
    SimpleChanges
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { RegistryItemSampleBoard } from "@app/strain/materials/models/registry-item-sample-board";

@Component({
    selector: 'app-sample-board-registry-items',
    templateUrl: './sample-board-registry-items.component.html',
    styleUrls: ['./sample-board-registry-items.component.scss']
})
export class SampleBoardRegistryItemsComponent implements OnChanges, OnInit, AfterContentInit {
    readonly i18nKey = 'admin.strain.sample-boards.details.tabs.documentation.registryItems';

    @Input() headerTitle?: string;
    @Input() headerSubtitle?: string;
    @Input() emptyText?: string;
    @Input() itemType: 'registry' | 'sampleBoard' = 'registry';
    @Input() items: RegistryItemSampleBoard[] = [];
    @Input() isLoading = false;
    @Output() openRegistry = new EventEmitter<RegistryItemSampleBoard>();

    @ContentChildren('[registryFooterActions]', { descendants: true }) footerActions: QueryList<any>;

    internalItems: RegistryItemSampleBoard[] = [];
    hasFooterActions = false;

    constructor(private translate: TranslateService) {
    }

    ngOnInit(): void {
        this.initializeItems();
    }

    ngAfterContentInit(): void {
        this.hasFooterActions = this.footerActions && this.footerActions.length > 0;
        this.footerActions?.changes?.subscribe((actions: QueryList<any>) => this.hasFooterActions = actions.length > 0);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['items']) {
            this.initializeItems();
        }
    }

    get resolvedHeaderTitle(): string {
        return this.headerTitle || this.translate.instant(`${this.i18nKey}.header.title`);
    }

    get resolvedHeaderSubtitle(): string {
        const count = (this.internalItems || []).length;
        return this.headerSubtitle || this.translate.instant(`${this.i18nKey}.header.subtitle`, { count });
    }

    get resolvedEmptyText(): string {
        return this.emptyText || this.translate.instant(`${this.i18nKey}.empty`);
    }

    private initializeItems(): void {
        this.internalItems = (this.items && this.items.length) ? this.items : [];
    }

    onOpenRegistry(item: RegistryItemSampleBoard): void {
        this.openRegistry.emit(item);
    }
}
